import { render, staticRenderFns } from "./ModulesGrid.vue?vue&type=template&id=2f04a7aa&scoped=true"
import script from "./ModulesGrid.vue?vue&type=script&lang=js"
export * from "./ModulesGrid.vue?vue&type=script&lang=js"
import style0 from "./ModulesGrid.vue?vue&type=style&index=0&id=2f04a7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f04a7aa",
  null
  
)

export default component.exports